import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../ts/Glob';
import { INotification } from '../../ts/stores/NotificationsStore';
import { Notification } from './Notification';

interface IWidgetNotificationsProps {
    runTimeWidgetID: number;
    showInPopup?: boolean;
    glob: IGlob;
}

function getState(props: IWidgetNotificationsProps) {
    const { runTimeWidgetID } = props;
    const { notifications } = props.glob.NotificationsStore.getState();

    let widgetNotifications: INotification[];

    if (notifications != null && notifications.length > 0) {
        if (runTimeWidgetID != null) {
            widgetNotifications = notifications.filter((notification) => {
                return notification.widgetRunTimeID === runTimeWidgetID;
            });
        } else if (props.showInPopup) {
            widgetNotifications = notifications.filter((notification) => {
                return notification.options != null && notification.options.showInPopup;
            });
        }
    }

    return {
        widgetNotifications: widgetNotifications
    };
}

export default function WidgetNotifications(props: IWidgetNotificationsProps) {
    const [state, setState] = React.useState(getState(props));

    React.useEffect(() => {
        const handleNotificationEvent = () => {
            setState(getState(props));
        };

        props.glob.NotificationsStore.addOnInWidgetNotificationListener(handleNotificationEvent);

        return () => {
            props.glob.NotificationsStore.removeOnInWidgetNotificationListener(handleNotificationEvent);
        };
    });

    const { widgetNotifications } = state;

    const notificationElements = _.map(widgetNotifications, (notification) => {
        return (
            <Notification
                key={notification.id}
                id={notification.id}
                value={notification}
                showInPopup={props.showInPopup}
                glob={props.glob}
            />
        );
    });

    let result: React.JSX.Element = null;

    if (notificationElements.length !== 0) {
        result = <div className="widget-notifications">{notificationElements}</div>;
    }

    return result;
}
